// extracted by mini-css-extract-plugin
module.exports = {"page":"player_page__QVvk0","container":"player_container__3iB8p","iframe":"player_iframe__1Dnbr","video":"player_video__1PEeo","show":"player_show__-uoaM"};